<template>
  <div>
    <template v-for="(ingredient, index) in ingredientsList">
      <portions
        v-if="portionWords.some(el => ingredient.includes(el))"
        :text="ingredient"
        :key="ingredient+index"
      />
      <h6 v-else-if="ingredient.includes(':')" :key="ingredient+index">{{ingredient}}</h6>
      <li
        :key="ingredient+index"
        v-else
        v-html="handleIngredient(ingredient).join(' ')"
        @click="checkIngredient(ingredient)"
        :class="{'checked': checked.includes(ingredient)}"
      ></li>
    </template>
  </div>
</template>

<script>
import portions from "@/components/pages/recipe/Portions";
export default {
  props: ["ingredients"],
  data() {
    return {
      portionWords: ["serveringer", "portioner", "person"],
      checked: [],
      original: [],
      ingredientsList: []
    };
  },
  methods: {
    setPortion(ratio) {
      this.ingredientsList = this.original.map(ingredient => {
        if (
          !this.portionWords.some(el => ingredient.includes(el)) &&
          !ingredient.includes(":")
        ) {
          return this.handleIngredient(ingredient, ratio).join(" ");
        } else {
          return ingredient;
        }
      });
    },
    checkIngredient(item) {
      if (this.checked.indexOf(item) == -1) this.checked.push(item);
      else this.checked.splice(this.checked.indexOf(item), 1);
    },
    handleIngredient(ingredientText, times = 1) {
      const numbers = /^\d+(\/\d+)*/;
      const words = ingredientText.split(" ");
      const newString = words.map(word => {
        if (word.match(numbers))
          if (times != 1) {
            if ((word * times).toFixed(2) == word * times) return word * times;
            else (word * times).toFixed(2);
          } else return `<span class="ingredient-number">${word}</span>`;
        else return word;
      });
      return newString;
    }
  },
  created() {
    this.ingredientsList = this.ingredients;
    this.original = this.ingredients;
  },
  components: {
    portions
  }
};
</script>

<style lang="scss">
.ingredients {
  padding: 0;
  .ingredients-content {
    background: white;
    border-radius: 10px;
    box-shadow: var(--cardshadow);
    .ingredient-number {
      font-weight: 600;
    }
    > div > div > h6 {
      padding-top: 20px;
      padding-bottom: 20px;
    }
  }
  li {
    list-style: none;
    cursor: pointer;
    font-size: 0.9rem;
    padding: 8px 20px 8px 30px;
    margin-top: 0 !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    list-style-position: inside;
    text-indent: -1em;
    &.checked {
      background: var(--main);
      color: white;
      &::before {
        color: white;
      }
    }
    &::before {
      content: "\00BB";
      color: var(--main);
      margin-left: 0;
      padding-right: 10px;
      // background: var(--lgray);
      // border-bottom: 0;
    }
  }
  h2 {
    padding: 20px 20px 0 20px;
  }
  h3 {
    padding: 0 20px;
    margin: 0 0 20px;
  }
  h6 {
    text-align: center;
    padding: 0 10px;
    text-transform: capitalize;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    margin-top: 0;
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .changeNumber {
    display: inline-block;
  }
}
</style>